export default __webpack_public_path__ + "assets/images/b76ab8c4e54b7dfb1a28f61c93ac1582.png";